/**
 * Factory to determine the avatar dropdown menu items based on the user's role and state.
 * 
 * - Cashier (role 3) should NOT see the 'Inicio' option.
 * - Impersonated sessions (isInpersonated === true) should see 'Volver a mi cuenta'.
 */
export const getAvatarMenuItems = ({ profile, isInpersonated, unpersonate, navigate, handleClose }) => {
    const roleId = profile?.colaborador?.role_id ?? profile?.role_id;
    const items = [];

    // 1. "Mi Perfil" (All roles see this)
    items.push({
        id: 'profile',
        label: 'Mi Perfil',
        icon: 'profile',
        onClick: () => {
            handleClose();
            navigate('/profile');
        }
    });

    // 2. "Inicio" (Everyone EXCEPT Cashier - role 3)
    if (roleId !== 3) {
        items.push({
            id: 'home',
            label: 'Inicio',
            icon: 'home',
            onClick: () => {
                handleClose();
                navigate('/hub');
            }
        });
    }

    // 3. "Volver a mi cuenta" (Only when impersonating a client)
    if (isInpersonated) {
        items.push({
            id: 'unpersonate',
            label: 'Volver a mi cuenta',
            icon: 'unpersonate',
            onClick: () => {
                handleClose();
                unpersonate();
            }
        });
    }

    return items;
};
